import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'objectToMap',
    standalone: false
})
export class ObjectToMapPipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        if (value !== Object(value)) {
            console.warn('Unable to convert input to map', value);

            return new Map();
        }

        return new Map(Object.entries(value));
    }
}
